import { DocumentAttributeWiringSection } from "~/components/domain/settings/documents/DocumentAttributeWiringSection";
import { DocumentSettingsEditor } from "~/components/domain/settings/documents/DocumentSettingsEditor";
import { DocumentTypedSignatureSettingsField } from "~/components/domain/settings/documents/DocumentTypedSignatureSettingsField";
import { OptInOrderDocumentAccessInfoAlert } from "~/components/domain/settings/documents/OptInOrderDocumentAccessInfoAlert";
import { BorderCanadaDocumentConfigSchema } from "~/modules/orders/order-documents/border-canada/config.schema";
import { useOptInOrderDocumentSettingsForm } from "~/modules/orders/order-menu-document-extensions/useOptInOrderDocumentSettingsForm";
import { ORDER_DOCUMENT_SLUG, orderDocumentMetadataBySlug } from "~/shared/documents/order-document-settings";
import {
  BORDER_CANADA_ATTRIBUTE_WIRE_CATALOG,
  mergeDocumentAttributeWiring,
} from "~/shared/documents/schemas/document-attribute-wiring.schema";
import { Divider, Input, Stack } from "~/ui";
import { emptyEditorDoc } from "~/utils/types/rich-text";

const BORDER_CANADA_SLUG = ORDER_DOCUMENT_SLUG.borderCanada;
const BORDER_CANADA_LABEL = orderDocumentMetadataBySlug[BORDER_CANADA_SLUG].menuLabel;

const defaultEmptyConfig = () =>
  BorderCanadaDocumentConfigSchema.parse({
    header: emptyEditorDoc(),
  });

/** Per-slug org settings editor for border-canada order document boilerplate. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const BorderCanadianOrderDocumentSettingsForm = () => {
  const { formElement } = useOptInOrderDocumentSettingsForm({
    slug: BORDER_CANADA_SLUG,
    schema: BorderCanadaDocumentConfigSchema,
    emptyConfig: defaultEmptyConfig(),
    saveErrorTitle: "Error while saving Border Canadian document settings",
    saveSuccessTitle: "Border Canadian document settings saved",
    infoAlert: <OptInOrderDocumentAccessInfoAlert documentLabel={BORDER_CANADA_LABEL} />,
    renderFields: (form, canEdit) => (
      <Stack spacing="md">
        <Input.Wrapper label="Header block">
          <DocumentSettingsEditor disabled={!canEdit} {...form.getInputProps("header")} />
        </Input.Wrapper>
        <DocumentTypedSignatureSettingsField
          canEdit={canEdit}
          createModalLabel="Border Canadian create"
          checked={form.values.allowTypedSignature}
          onChange={checked => form.setFieldValue("allowTypedSignature", checked)}
        />
        <Divider />
        <DocumentAttributeWiringSection
          catalog={BORDER_CANADA_ATTRIBUTE_WIRE_CATALOG}
          wiring={form.values.attributeWiring ?? {}}
          onWireChange={(wireKey, attributeIds) =>
            form.setFieldValue("attributeWiring", mergeDocumentAttributeWiring(form.values.attributeWiring, wireKey, attributeIds))
          }
          canEdit={canEdit}
        />
      </Stack>
    ),
  });

  return formElement;
};
